import { AppBox } from "../../../../../commons/components";
import { User } from "../../../../../commons/models/user";
import { toTitleCase } from "../../../../../commons/utilities/string-utils";

interface TeamManagerAddConfirmProps {
  user: User;
}
export default function TeamManagerAddConfirm({ user }: TeamManagerAddConfirmProps) {
  return (
    <AppBox displayBlock>
      Do you want to add <strong>“{toTitleCase(user.fullName)}” </strong> to the team as manager?
    </AppBox>
  );
}
